import { useEffect } from 'react';
import useAuthStore from '../../store/useAuthStore';
import { useGetUserDetail } from '../../assets/api/UseStudentGetApi';
import { getCookie } from '../utils/CookieUtils';
import { bootstrapAuth } from '../utils/BootstrapAuth';

export const useSyncUser = () => {
  const { token, login } = useAuthStore();
  const { data, isLoading } = useGetUserDetail();

  const userDetail = data?.data;

  useEffect(() => {
    bootstrapAuth();
  }, []);

  useEffect(() => {
    if (userDetail) {
      console.log("🔄 Syncing user detail to store...");
      const accessToken = getCookie("accessToken") || 'true';
      const refreshToken = getCookie("refreshToken") || 'true' ;

      login(userDetail, accessToken, refreshToken);
    }
  }, [userDetail, token, login]);

  return { userDetail, isLoading };
};
